import axios from "axios";
import config from "../config";

const Api = axios.create({
  baseURL: config.serverURI(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default Api;
